export class IdentitiesFacade {
    constructor(sdk) {
        this.sdk = sdk;
    }
    async fetch(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentity(identityId);
    }
    async fetchWithProof(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityWithProofInfo(identityId);
    }
    async fetchUnproved(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityUnproved(identityId);
    }
    async getKeys(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityKeys(query);
    }
    async getKeysWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityKeysWithProofInfo(query);
    }
    async nonce(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityNonce(identityId);
    }
    async nonceWithProof(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityNonceWithProofInfo(identityId);
    }
    async contractNonce(identityId, contractId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityContractNonce(identityId, contractId);
    }
    async contractNonceWithProof(identityId, contractId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityContractNonceWithProofInfo(identityId, contractId);
    }
    async balance(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityBalance(identityId);
    }
    async balanceWithProof(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityBalanceWithProofInfo(identityId);
    }
    async balances(identityIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentitiesBalances(identityIds);
    }
    async balancesWithProof(identityIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentitiesBalancesWithProofInfo(identityIds);
    }
    async balanceAndRevision(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityBalanceAndRevision(identityId);
    }
    async balanceAndRevisionWithProof(identityId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityBalanceAndRevisionWithProofInfo(identityId);
    }
    async byPublicKeyHash(publicKeyHash) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityByPublicKeyHash(publicKeyHash);
    }
    async byPublicKeyHashWithProof(publicKeyHash) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityByPublicKeyHashWithProofInfo(publicKeyHash);
    }
    async byNonUniquePublicKeyHash(publicKeyHash, startAfter) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityByNonUniquePublicKeyHash(publicKeyHash, startAfter);
    }
    async byNonUniquePublicKeyHashWithProof(publicKeyHash, startAfter) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityByNonUniquePublicKeyHashWithProofInfo(publicKeyHash, startAfter || undefined);
    }
    async contractKeys(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentitiesContractKeys(query);
    }
    async contractKeysWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentitiesContractKeysWithProofInfo(query);
    }
    async tokenBalances(identityId, tokenIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityTokenBalances(identityId, tokenIds);
    }
    async tokenBalancesWithProof(identityId, tokenIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityTokenBalancesWithProofInfo(identityId, tokenIds);
    }
    async create(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.identityCreate(options);
    }
    async topUp(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.identityTopUp(options);
    }
    async creditTransfer(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.identityCreditTransfer(options);
    }
    async creditWithdrawal(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.identityCreditWithdrawal(options);
    }
    async update(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.identityUpdate(options);
    }
}
